import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router, UrlSegment } from '@angular/router';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import { environment } from "./../../../../environments/environment";
import { UserService } from 'src/app/services/user.service';
interface Clientes{
  value: number;
  name: string;
}
@Component({
  selector: 'app-ver-cerveza',
  templateUrl: './ver-cerveza.component.html',
  styleUrls: ['./ver-cerveza.component.css']
})
export class VerCervezaComponent {

  cervezaCreada: boolean = false;
  waitAfterSave: boolean = false;
  cervezaId: any;
  beerData: any = [];
  beerImg: any;
  beerDataImgPath: string = "";
  nombreCliente: string = "";

  //IMAGEN
  formData : FormData = new FormData();
  file: File | undefined;
  reader = new FileReader();
  imageUrl: string | ArrayBuffer | null = null;
  
  //ERROR
  nombreError: boolean = false;
  clienteIdError: boolean = false;
  errorMessage: string = "";
  errorFinal: boolean = false;
  showImageErrorMessage: boolean = false;
  showImageErrorMessageShow: boolean = false;

  clientes: Clientes[] = [];
  selectedCliente: number | undefined;

  signin: FormGroup = new FormGroup({
    nombre: new FormControl(''),
  });

  urlBase: string = "";

  private cervezaSubscription: Subscription | undefined;
  private editarProductoSubscription: Subscription | undefined;

  constructor(private error429: Error429Service, private router: Router,
    private deviceService: DeviceService){
    this.cervezaId = this.getCervezaIdFromCurrentPath(router);
    this.urlBase = environment.urlNonce;
  }

  ngOnInit(): void {
    this.cervezaSubscription = this.deviceService.getOneBeerType(this.cervezaId).subscribe({
      next: resp =>{
        this.beerData = resp;
        console.log(resp);
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{
        this.signin.patchValue({
          nombre: this.beerData.name
        });
        this.nombreCliente = this.beerData.cliente.razon_social;
        console.log(this.nombreCliente);
        this.selectedCliente = this.beerData.cliente_id;
        this.beerImg = this.beerData.img;
        console.log(this.beerImg);
        this.beerDataImgPath = this.urlBase +"/uploads/imgs/"+ this.beerImg;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.cervezaSubscription) {
      this.cervezaSubscription.unsubscribe();
    } 
    if (this.editarProductoSubscription) {
      this.editarProductoSubscription.unsubscribe();
    } 
  }

  previewImage() {
    this.reader.onload = () => {
      this.imageUrl = this.reader.result;
      /*if (typeof this.reader.result === 'string') {
        this.base64Image = this.reader.result.split(',')[1];
        console.log(this.base64Image);
      }*/
    };
    this.reader.readAsDataURL(this.file as Blob);
  }

  onFileSelected(event: any) {
    //this.file = (event.target as HTMLInputElement).files[0];
    this.file = event.target.files[0];
    if (this.file && this.file !==undefined && this.file.type === 'image/jpeg') {
      this.previewImage();
      this.showImageErrorMessage = false;
      this.formData.append('img', this.file as Blob);
    } else {
      this.imageUrl = null;
      this.showImageErrorMessage = true;
    }
    if(this.file == undefined){
      this.showImageErrorMessage = false;
    }
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  getCervezaIdFromCurrentPath(router: Router): number {
    const urlTree = router.parseUrl(router.url);
    const segments: UrlSegment[] = urlTree.root.children['primary'].segments;
    // Buscamos el segmento que contiene el número
    let deviceId: number | null = null;
    for (const segment of segments) {
      const value = parseInt(segment.path, 10);
      if (!isNaN(value)) {
        deviceId = value;
        break;
      }
    }
    return deviceId || 0;
  }

  get nombreInput() { 
    return this.signin.get('nombre'); 
  }

  clearField(fieldName: string) {
    this.signin.get(fieldName)?.setValue('');
  }
}
